/**
 * User: daletan
 * Date: 3/24/15
 * Time: 6:41 PM
 * Copyright 1stdibs.com, Inc. 2015. All Rights Reserved.
 */

'use strict';

module.exports = typeof window === 'undefined' ? global : window;



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/helpers/windowCheck.js
// module id = 100
// module chunks = 63